var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{show:!_vm.isLoading}},[_c('side-bar'),_c('div',{staticClass:"main-panel"},[_c('nav-bar'),_c('transition',{attrs:{"name":"fade-wrapper"}},[_c('router-view',{staticClass:"content"})],1),_c('footer-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }